export const isBetaSite = (): boolean => {
  const locationPath = window.location.origin;
  return locationPath.includes('beta.readysetvr.com');
};

export const getSiteEnvironment = (): string => {
  const locationPath = window.location.origin;
  if (locationPath.includes('dev.readysetvr.com')) return 'dev';
  if (locationPath.includes('qa.readysetvr.com')) return 'qa';
  if (locationPath.includes('beta.readysetvr.com')) return 'beta';
  if (locationPath.includes('staging.readysetvr.com')) return 'staging';
  if (locationPath.includes('readysetvr.com')) return 'production';
  return 'dev';
};
